export const QUERIES = {
  EMAIL_UPDATES: 'email_updates',
} as const

export const emailUpdateKeys = {
  all: (draftsOnly: boolean) => [QUERIES.EMAIL_UPDATES, draftsOnly] as const,
}
